<template lang="pug">
    .modal-card
        .modal-card-head
          .title(style="color:black") {{stop_timers}}
        .modal-card-body
          section.message.is-medium
            .message-body
              p {{stop_timers_message}}
          button(style="margin:1rem").button.is-large.is-info(@click="close_running_prompt") OK


</template>

<script>
import { mapState } from "vuex";
export default {
  name: "StopTimers",
  props: {},
  date: function() {
    return {};
  },
  computed: {
    ...mapState(["language"]),
    stop_timers() {
      if (this.language == "en") return "Stop timers";
      else return "Detener temporizadores";
    },
    stop_timers_message() {
      if (this.language == "en")
        return "You must stop all work and break timers before performing this action.";
      else
        return "Debe detener todo el trabajo y romper los temporizadores antes de realizar esta acción.";
    }
  },
  methods: {
    close_running_prompt() {
      this.$emit("prompt-closed");
    }
  }
};
</script>

<style scoped lang="less">
.modal-card {
  max-width: 500px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}
</style>
